// @ts-ignore
import React, { HTMLAttributes } from 'react'

interface Props
  extends HTMLAttributes<HTMLAnchorElement>,
    HTMLHyperlinkElementUtils {
  children?: React.ReactNode
  target?: string
}

export default function PreventDefaultAnchor({
  children,
  onClick,
  target,
  ...rest
}: Props) {
  return (
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault()
        onClick?.(e)
      }}
      target={target}
      {...rest}
    >
      {children}
    </a>
  )
}

interface HTMLHyperlinkElementUtils {
  href?: string
}
